import React from 'react';
import SignInButton from './SignInButton';
import SignInWithMicrosoftSVG from './SignInWithMicrosoft.svg';
import SignInWithGoogleSVG from './SignInWithGoogle.svg';

const EmailIntegrationProviders = () => {
    return (
        <div className="flex flex-col gap-4" data-cy="IntegrationProviders">
            <SignInButton src={SignInWithGoogleSVG} value="google" objectStyle={{ borderRadius: '4px' }} />
            <SignInButton src={SignInWithMicrosoftSVG} value="microsoft" />
        </div>
    );
};

export default EmailIntegrationProviders;
